import { usePrefetchBlckTickLottie } from "./usePrefetchBlckTickLottie";
import { usePrefetchBoltLottie } from "./usePrefetchBoltLottie";
import { usePrefetchCartHeaderLottie } from "./usePrefetchCartHeaderLottie";
import { usePrefetchDetipLottie } from "./usePrefetchDetipLottie";
import { usePrefetchPlanRemovalLottie } from "./usePrefetchPlanRemovalLottie";
import { usePrefetchTickScreenLottie } from "./usePrefetchTickScreenLottie";
import { usePrefetchSnaccFreebieLottie } from "./usePrefetchSnaccFreebieLottie";
import { usePrefetchSplashLotties } from "./usePrefetchSplashLotties";

export const usePrefetchlottie = () => {
    usePrefetchCartHeaderLottie();
    usePrefetchBlckTickLottie();
    usePrefetchBoltLottie();
    usePrefetchTickScreenLottie();
    usePrefetchDetipLottie();
    usePrefetchPlanRemovalLottie();
    usePrefetchSnaccFreebieLottie();
    usePrefetchSplashLotties();
};
